// eslint-disable-next-line no-restricted-imports
import './tailwind.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App/App';
import {rootErrorHandlers} from './utils/reactRootErrorHandlers';

const rootElement = document.getElementById('root');
// React 19 root error hooks (CAD-6757). See reactRootErrorHandlers.ts for why
// onCaughtError does not capture — the ErrorBoundary owns those events so its
// isolation-point tags survive.
const root = ReactDOM.createRoot(rootElement!, rootErrorHandlers);

if (import.meta.env.MODE === 'development') {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  root.render(<App />);
}
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/service-worker.js')
    .then(() => console.info('Service Worker registered!'))
    .catch((err) => console.error('Service Worker registration failed:', err));
}
